import script from "./BaseRange.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRange.vue?vue&type=script&setup=true&lang=js"

import "./BaseRange.vue?vue&type=style&index=0&id=d0e395ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0e395ce"]])

export default __exports__